import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { RappiderTextModule } from '../text/text.module';
import { RappiderHeadingModule } from '../heading/heading.module';

import { CollapseIconPosition } from '../../utils/collapse/collapse-icon-position.enum';
import { Panel } from '../../utils/panel/panel.interface';
import {
  BorderConfig,
  BoxShadowConfig,
  ColorConfig,
  SizeConfig,
  SpacingConfig,
} from '../../utils/shared';
import { computeBorderStyles } from '../../utils/set-border-and-radius';

@Component({
  selector: 'rappider-accordion',
  standalone: true,
  imports: [
    CommonModule,
    NzCollapseModule,
    RappiderTextModule,
    RappiderHeadingModule
  ],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class RappiderAccordionComponent implements OnInit {
  @Input() panels: Panel[];
  @Input() bordered: boolean;
  @Input() collapseIconPosition: CollapseIconPosition;
  @Input() borderSettings: BorderConfig;
  @Input() sizeSettings: SizeConfig;
  @Input() colorSettings: ColorConfig;
  @Input() boxShadowSettings: BoxShadowConfig;
  @Input() paddingSettings: SpacingConfig;
  @Input() marginSettings: SpacingConfig;

  borderStyles: any = {};

  ngOnInit(): void {
    this.setBorderStyles();
  }

  setBorderStyles(): any {
    this.borderStyles = computeBorderStyles({
      border: this.borderSettings?.border || null,
      borderRadius: this.borderSettings?.borderRadius || null
    });
  }

}
